<div class="sign-in-ctn text-small d-inline-flex mx-2"
    (mouseenter)="mouseEnter()"
    (mouseleave)="mouseLeave()"
    (click)="navToUser()"
    >
    <div class="sign-in d-flex align-items-center" title="福利">
         <span class="iconfont iconliwu fs-32"></span>
        <!-- <img class="mr-2"
             src="./assets/images/daily-sign-in/sign-in-icon.png" /> -->
        <!-- <img class="mr-2"
             style="width: 24px;"
             src="./assets/images/daily-sign-in/gift.png" /> -->
        <!-- <span class="new-label">NEW</span> -->
        <!-- <span class="sign-in-text"
              style="width: 28px;">签到</span> -->
        <!-- <span class="sign-in-text"
              style="width: 2.5em;"></span> -->
        </div>
    <app-sign-in-expanded [signInData]="signInData"
                          [isLoading]="isLoading"
                          [userId]="lastId"
                          [hide]="!expand"></app-sign-in-expanded>
</div>
